import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Para obtener el ID de la rifa del URL
import {
  doc,
  getDoc,
  onSnapshot,
  collection,
  where,
  query,
} from "firebase/firestore";
import { db } from "../firebase"; // Configuración de Firebase
import RaffleTicket from "./RaffleTicket";
import { convertImageToBase64, getStatusIcon } from "../utils";
import HeaderRaffle from "./HeaderRaffle";
import { QRCode } from "react-qrcode-logo";
import { IoMdShare } from "react-icons/io";
import { BsQrCode } from "react-icons/bs";
import { formatedDate } from "../utils";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
} from "@material-tailwind/react";
import { FooterWithSocialLinks } from "./Footer";
import imageUrl from "../assets/promotion_image.png";

const RaffleDetails = ({ isAdmin }) => {
  const { id } = useParams(); // Obtenemos el id del URL

  const [startNumber, setStartNumber] = useState(1);
  const [endNumber, setEndNumber] = useState(10);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [ticketIcons, setTicketIcons] = useState({});
  const [infoRaffle, setInfoRaffle] = useState({});
  const [listTickets, setListTickets] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchRaffleDetails = async () => {
      const docRef = doc(db, "raffles", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setInfoRaffle(data);
        setStartNumber(data.startTicket || 1);
        setEndNumber(data.endTicket || 10);

      } else {
        console.error("No such raffle document!");
      }
    };

    if (id) {
      fetchRaffleDetails();
    }
  }, [id]);

  useEffect(() => {
    if (id) { // Asegúrate de que haya un id de rifa
      const q = query(
        collection(db, "tickets"),
        where("raffleId", "==", id) // Filtra por el raffleId
      );
  
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const icons = {};
        const tickets = [];
  
        querySnapshot.forEach((doc) => {
          const data = doc.data();          
  
          tickets.push(data);
          icons[data.number] = getStatusIcon(Number(data.status));
        });
        setListTickets(tickets);
        setTicketIcons(icons);
      });
  
      return () => unsubscribe();
    }
  }, [id]);

  const handleGenerate = () => {
    const range = [];
    for (let i = startNumber; i <= endNumber; i++) {
      range.push(i);
    }
    return range;
  };

  const generatedNumbers = handleGenerate();

  // Obtiene la URL actual de la página
  const currentUrl = window.location.origin + "/raffles/public/" + id;

  // Función para compartir el URL
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: infoRaffle?.title,
          text: `${
            infoRaffle?.title
          } - ¡Mira esta rifa y elige tus números favoritos! Juega el ${formatedDate(
            infoRaffle?.drawDate
          )}. Haz click aquí para mas detalles: ${currentUrl}`,
          // url: currentUrl,
        });
        console.log("Compartido exitosamente");
      } catch (error) {
        console.error("Error al compartir", error);
      }
    } else {
      alert("En estos momentos no es posible compartir este link.");
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openQRModal = () => {
    openModal();
  };

  const [selectedStatus, setSelectedStatus] = useState(null); // Estado seleccionado para filtro

  // Manejar cambio de filtro
  const handleStatusFilterChange = (status) => {
    setSelectedStatus(status || null); // Asegúrate de que "Todos" se maneje como null
  };

  const filteredTickets = listTickets.filter((ticket) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      ticket.name?.toLowerCase().includes(searchLower) || // Filtrar por nombre
      ticket.phone?.toLowerCase().includes(searchLower) || // Filtrar por teléfono
      String(ticket.number).includes(searchTerm)           // Filtrar por número de ticket
    );
  });


  const filteredNumbers = generatedNumbers.filter((num) => {
    const ticket = listTickets.find((ticket) => ticket.number === num);
    
    // Filtrar por término de búsqueda
    const matchesSearchTerm = !searchTerm || (
      ticket?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket?.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(ticket?.number).includes(searchTerm)
      || num.toString().includes(searchTerm)
    );
  

    // Filtrar por estado seleccionado
   const matchesStatus = selectedStatus === null || selectedStatus === "" || (
    (selectedStatus === 1 && (!ticket || (ticket.status !== 2 && ticket.status !== 3))) ||
    (selectedStatus === 2 && ticket?.status === 2) ||
    (selectedStatus === 3 && ticket?.status === 3)
  );

    // Retornar solo si coincide con ambos criterios
    return matchesSearchTerm && matchesStatus;
  });


  return (
    <>
      <Dialog open={isOpen} handler={setIsOpen}>
        <DialogHeader>Compartir QR - TicketWin</DialogHeader>
        <DialogBody divider>
          <div className="flex flex-col items-center">
            <h1 className="font-bold" style={{ fontSize: "18px" }}>
              {infoRaffle?.title}
            </h1>
            <small className="mb-4">{formatedDate(infoRaffle?.drawDate)}</small>
            <small>Escanea este código QR para acceder a la rifa</small>
            <QRCode
              value={currentUrl}
              size={200}
              bgColor="white"
              fgColor="black"
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button color="red" onClick={closeModal}>
            Cerrar
          </Button>
        </DialogFooter>
      </Dialog>
      <div>
        <HeaderRaffle
          title={infoRaffle?.title}
          startTicket={infoRaffle?.startTicket}
          endTicket={infoRaffle?.endTicket}
          dateRuffle={infoRaffle?.drawDate}
          contactName={infoRaffle?.contactName}
          contactPhone={infoRaffle?.contactNumber}
          ticketsData={listTickets}
          isAdmin={isAdmin}
          imageUrl={infoRaffle?.imageUrl ?? imageUrl}
        />
      </div>

      <div>
        <div
          style={{
            position: "sticky",
            top: "5px",
            zIndex: "100",
          }}
        >
          {selectedNumber !== null && (
            <RaffleTicket
              number={selectedNumber}
              setNumber={setSelectedNumber}
              raffleId={id}
              onlyView={isAdmin}
              handleSelectNum={setSelectedNumber}
              imageUrl={ infoRaffle?.imageUrl  ?? imageUrl}
              ticketList={filteredNumbers}
            />
          )}
        </div>
        <div className="p-4 flex flex-col md:flex-col items-center md:items-start md:space-x-4">


<div className="py-4 mb-4 w-full" style={{
  borderBottom:"1px dashed gray"
}}>
  
<div className="flex gap-4">
          <div className="mb-4 flex flex-col">
            <small htmlFor="statusFilter" className="mr-2 mb-2 font-bold">
              Filtrar por estado:
            </small>
            <select
              id="statusFilter"
              value={selectedStatus || ""}
              onChange={(e) => handleStatusFilterChange(Number(e.target.value))}
              className="border border-gray-400 p-2 rounded mb-2"
            >
              <option value="">Todos</option>
              <option value="1">Disponibles</option>
              <option value="2">{getStatusIcon(2)} Reservados</option>
              <option value="3">{getStatusIcon(3)} Vendidos</option>
            </select>
          </div>

          <div className="mb-4 flex flex-col">
          <small htmlFor="statusFilter" className="mr-2 mb-2 font-bold">
          🔎 Buscar:
            </small>
            <input
              type="text"
              placeholder="Buscar..."
              className="border border-gray-400 p-2 rounded mb-2 w-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
</div>
             {/* Mostrar el total de boletos filtrados */}
             <div className="mb-2">
            <p className="text-gray-600">
              {selectedStatus === 1
                ? `Total de boletos 🎟️ Disponibles: `
                : selectedStatus === 2
                ? `Total de boletos 🎟️ Reservados: `
                : selectedStatus === 3
                ? `Total de boletos 🎟️ Vendidos: `
                : `Total de boletos encontrados: `}
              <strong>{filteredNumbers.length}</strong>
            </p>
          </div>
         
</div>

          {/* Lista de números generados */}
          <div className="w-full">
            <h2 className="mb-4 font-bold">Seleccione un número:</h2>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(100px,1fr))] gap-4">
               {filteredNumbers.map((num) => {
            const ticket = filteredTickets.find((ticket) => ticket.number === num);

            let bgColor = "bg-white"; // Disponible (1)
            let textColor = "text-gray-800"; // Texto para disponible
            if (ticket?.status === 2) {
              bgColor = "bg-gray-300"; // Reservado (2)
              textColor = "text-gray-600"; // Texto para reservado
            } else if (ticket?.status === 3) {
              bgColor = "bg-green-300"; // Vendido (3)
              textColor = "text-green-700"; // Texto para vendido
            }

            return (
              <div
                key={num}
                className={`text-center ${bgColor} ${textColor} hover:bg-gray-100 font-semibold py-2 px-4 border border-gray-400 rounded shadow`}
                onClick={() => setSelectedNumber(num)}
                style={{
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0",
                    fontSize: "15px",
                  }}
                >
                  {ticketIcons[num]}
                </div>
                N° {((num < 10) ? `0${Number(num)}` : `${Number(num)}`)}
              </div>
            );
          })}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "60px",
          right: "25px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          zIndex: "999",
        }}
      >
        <div
          style={{
            background: "#2E2E2E",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
          }}
          onClick={openQRModal}
        >
          <BsQrCode size={30} />
        </div>
        <div
          onClick={handleShare}
          style={{
            background: "#2E2E2E",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
          }}
        >
          <IoMdShare size={30} />
        </div>
      </div>

      <FooterWithSocialLinks />
    </>
  );
};

export default RaffleDetails;
